export default __webpack_public_path__ + "static/media/port.9efa0065.svg";